import React from 'react';

import BreakpointProvider from './BreakpointProvider';

const AppProvider = ({ children }) => {
    return <BreakpointProvider>{children}</BreakpointProvider>;
};

export default AppProvider;
